module.exports = __webpack_public_path__ + "static/media/B1.c4d27a68.jpg";